/**
 * Extracts initials from a contact name
 * @param name - The full name of the contact
 * @returns The initials (up to 2 characters)
 */
export function getContactInitials(name: string): string {
  if (!name || name.trim() === '') {
    return '??';
  }

  const words = name
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0);
  if (words.length === 0) {
    return '??';
  }

  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  } else {
    const firstInitial = words[0].charAt(0);
    const secondInitial = words[words.length - 1]?.charAt(0) || '';

    return (firstInitial + secondInitial).toUpperCase();
  }
}
